import React, { Component } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import { store } from '../../store';
import {
  showAlert as storeShowAlert,
  hideAlert as storeHideAlert,
} from '../../actions/actions';

import styles from './Alerts.scss';

const mapStateToProps = state => {
  return {
    alerts: state.alerts
  };
};

@connect(mapStateToProps)
export class Alerts extends Component {
  render(){
    const { className, alerts } = this.props;
    return (
      <div className={className}>
        {Boolean(alerts.length) && alerts.map(alert => (
          <div className={cn({
              [styles.alert]: true,
              [styles.alertTypeError]: alert.type === 'error',
            })}
            key={alert.id}
            id={'alert-' + alert.id}>
            {alert.type !== 'error' && (
              <h5 className={styles.alertHeader}>Уведомление</h5>
            )}
            {alert.type === 'error' && (
              <h5 className={styles.alertHeader}>Ошибка</h5>
            )}
            <div className={styles.alertText}>{alert.text.substr(0 ,250)}</div>
            <i className={cn(styles.alertClose, 'icon-close-thick')}
              onClick={() => hideAlert(alert.id)}/>
          </div>
        ))}
      </div>
    );
  }
}

export function showAlert(params){
  store.dispatch(storeShowAlert(params));
  const updatedAlerts = store.getState().alerts;
  return updatedAlerts[updatedAlerts.length - 1];
}

export function hideAlert(alertId){
  const alertElement = document.getElementById('alert-' + alertId);
  if (!alertElement) {
    return;
  }
  alertElement.classList.add('globalSlideLeft');
  setTimeout(() => {
    alertElement.classList.remove('globalSlideLeft');
    store.dispatch(storeHideAlert(alertId));
  }, 400);
}
